import type { HelpFile } from '../../types/help'
import { OwnersSectionTestIds } from '../../../testids/OwnersSectionTestIds'

export const ownersSectionHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [OwnersSectionTestIds.sectionOwners]:
      'Parties accountable for this entity and the responsibilities they hold.',
    [OwnersSectionTestIds.addOwnerForm]: null,
    [OwnersSectionTestIds.btnAddOwner]:
      'Assign a new owner to this entity.',
    [OwnersSectionTestIds.btnCancelAddOwner]: null,
    [OwnersSectionTestIds.btnSaveAddOwner]: null,
    [OwnersSectionTestIds.colOwnerActions]: null,
    [OwnersSectionTestIds.colOwnerParty]:
      'Party that owns or is responsible for this entity.',
    [OwnersSectionTestIds.colOwnerResponsibility]:
      'Kind of responsibility — business owner, technical owner, or steward.',
    [OwnersSectionTestIds.colOwnerValidFrom]:
      'Date this ownership assignment becomes effective.',
    [OwnersSectionTestIds.colOwnerValidTo]:
      'Date this ownership assignment ends, if any.',
    [OwnersSectionTestIds.comboboxAddOwnerParty]:
      'Search for a party to assign as owner.',
    [OwnersSectionTestIds.selectAddOwnerResponsibility]:
      'Kind of responsibility the new owner takes. The available options come from the per-entity responsibility lookup; when only one role is configured, this field is hidden and the role is set automatically.',
    [OwnersSectionTestIds.optionResponsibilityPrefix()]: null,
    [OwnersSectionTestIds.responsibilityLookupMissingError]: null,
  },
}
